import React, { FC } from 'react';
import classNames from 'classnames';
import './GlobalFooter.less';

export interface GlobalFooterProps {
  links?: Array<{
    key?: string;
    title: React.ReactNode;
    href: string;
    blankTarget?: boolean;
  }>;
  copyright?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export const GlobalFooter: FC<GlobalFooterProps> = ({ className, links, copyright }) => {
  const clsString = classNames('globalFooter', className);
  return (
    <footer className={clsString}>
      {links && (
        <div className="links">
          {links.map(link => (
            <a key={link.key} title={link.key} target={link.blankTarget ? '_blank' : '_self'} href={link.href}>
              {link.title}
            </a>
          ))}
        </div>
      )}
      {copyright && (
        <div className="copyright">
          {copyright} &copy; {new Date().getFullYear()}
        </div>
      )}
    </footer>
  );
};
